import React, { memo, useEffect, useLayoutEffect, useState } from 'react';
import styles from './loadsCard.module.scss';
import { TaskObject } from './taskObject';
import { TaskBlock } from './singleLoadCard';
import { calculateOffset } from './loadObject';
import { HomeTime } from './loadObject';
import { DAY_WIDTH_IN_PIXELS } from '../plannerViewTeamCard';
import { useBoardStore } from '../../boardStore';
import { RiAddLine } from "react-icons/ri";
import { AddNewTaskMethod } from '../../../general_components/content_management/task_list/taskListElements/addNewTask';
import { addPopup } from '../../../supplementary_components/store';
import { Form } from '../../../general_components/forms/Form';
import { AddLoadToTruckPopup } from '../../../pages/trucks/truckPageConfComponents';
import { canSeeLoadRates } from '../../../supplementary_components/userDataDelegate';



const TASK_WIDTH_IN_PIXELS = 32.4;
const getOffsetByTaskId = (taskId, truckBoxRef, currentTasksArray, rightBorder, loads) => {
    if (!taskId) {
        return null;
    }
    try {
        if (currentTasksArray) {
            const timeSpecifiedTask = currentTasksArray.find(obj => obj.id === taskId);
            //"066ec64d-6d0d-42fd-ac19-c53f980fc9fc"


            if (timeSpecifiedTask) {
                const result = timeSpecifiedTask.startOffset + (rightBorder ? timeSpecifiedTask.width + TASK_WIDTH_IN_PIXELS / 2 : 0);
                const type = timeSpecifiedTask.type;

                return rightBorder ? result : (((type === "homeTime" || type === "reset") && result < DAY_WIDTH_IN_PIXELS) || (type !== "homeTime" && type !== 'reset')) ? result : null;
            }
        }
        if (taskId.startsWith("Load")) {
            const stopInfo = taskId.split("StopIndex");
            const loadTag = truckBoxRef.querySelector(`[id="${stopInfo[0]}"]`);
            const stopIndex = parseInt(stopInfo[1]);
            if (!loadTag) {
                if (loads) {
                    const load = loads.find(obj => `Load${obj.loadNumber}` === stopInfo[0]);
                    if (load) {
                        if (stopIndex === 0) {
                            return load.startOffset;
                        } else {
                            return load.startOffset + load.width;
                        }
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            }
            const loadStartOffset = parseInt(loadTag.style.left);

            if (stopIndex === 0) {
                return loadStartOffset;
            } else if (loadTag.querySelectorAll(":scope > span").length >= stopIndex) {
                return loadStartOffset + parseInt(getComputedStyle(loadTag.children[stopIndex - 1]).left);
            } else {
                return loadStartOffset + parseInt(loadTag.style.width);
            }
        }
    } catch (error) {
        console.log(error)
    }
    return null;
}

export const ExtraStopsAndTasksObject = memo(({ truckBoxRef, truckId, truckNumber, trucksSetDataMethodsObject, timelineStartInMills, currentTimeRef, overflowContainer, popupViewManagingObject, lastSpecifiedOffset, lastSpecifiedOffsetForCompletedTasks, loads, taskCount }) => {
    const plannerTick = useBoardStore((s) => s.plannerTick);

    const stopsAndTasksObjectFromStore = useBoardStore((s) =>
        truckId != null ? s.trucksById?.[String(truckId)]?.loadStopsAndTasksObject : null
    );
    const stopsAndTasksObject = stopsAndTasksObjectFromStore || null;

    const [tasks, setTasks] = useState([]);
    const [currentTimeDependenTasks, setCurrentTimeDependenTasks] = useState(false);

    // Ensure we re-render once after mount so refs are populated and DOM offsets can be computed.
    useEffect(() => {
        try {
            if (!truckBoxRef?.current) return;
            const bumpPlannerTick = useBoardStore.getState().bumpPlannerTick;
            if (typeof bumpPlannerTick === "function") bumpPlannerTick();
        } catch (e) { }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Backwards-compatible hook: allow callers to "poke" the visual update.
    useEffect(() => {
        if (!trucksSetDataMethodsObject || !truckNumber) return;
        trucksSetDataMethodsObject[truckNumber + "extraStops"] = () => {
            try {
                const bumpPlannerTick = useBoardStore.getState().bumpPlannerTick;
                if (typeof bumpPlannerTick === "function") bumpPlannerTick();
            } catch (e) { }
        };
        return () => {
            try {
                delete trucksSetDataMethodsObject[truckNumber + "extraStops"];
            } catch (e) { }
        };
    }, [trucksSetDataMethodsObject, truckNumber, truckBoxRef]);

    // IMPORTANT: Any DOM reads/writes that depend on LoadsCard's latest DOM must happen
    // after React commits. Doing this inside render can race and produce stale/missing nodes.
    useLayoutEffect(() => {
        const truckBoxEl = truckBoxRef?.current;
        if (!truckBoxEl || !stopsAndTasksObject) {
            setTasks([]);
            setCurrentTimeDependenTasks(false);
            return;
        }

        let nextCurrentTimeDependenTasks = false;
        const nextTasks = [];

        if (stopsAndTasksObject.timeSpecifiedTasks) {
            for (let timeSpecifiedTasks of stopsAndTasksObject.timeSpecifiedTasks) {
                nextTasks.push(new TaskObject(timeSpecifiedTasks, timelineStartInMills, null));
            }
        }

        if (stopsAndTasksObject.longTasks) {
            let lastLongTaskId = null;
            for (let i = 0; i < stopsAndTasksObject.longTasks.length; i++) {
                const longTask = stopsAndTasksObject.longTasks[i];
                if (longTask.positionSpecified || lastLongTaskId === longTask.taskIdToTheLeft) {
                    let leftBorder = longTask.taskIdToTheLeft
                        ? getOffsetByTaskId(longTask.taskIdToTheLeft, truckBoxEl, nextTasks, true, loads)
                        : lastSpecifiedOffsetForCompletedTasks;
                    let rightOffset = getOffsetByTaskId(longTask.taskIdToTheRight, truckBoxEl, nextTasks, false, loads);

                    if (leftBorder === null && i === 0 && (rightOffset === null || rightOffset > lastSpecifiedOffset)) {
                        leftBorder = lastSpecifiedOffset;
                    }

                    nextTasks.push(new HomeTime(longTask, timelineStartInMills, leftBorder, rightOffset, currentTimeRef));
                    lastLongTaskId = longTask.id;
                }
            }
        }

        if (stopsAndTasksObject.timeUnspecifiedTasks) {
            for (let i = 0; i < stopsAndTasksObject.timeUnspecifiedTasks.length; i++) {
                let currentTask = stopsAndTasksObject.timeUnspecifiedTasks[i];

                let startingTaskIndex = i;
                let leftBorderOffset = 0;
                let rightBorderOffset = null;

                if (currentTask.id.startsWith("Load")) {
                    nextTasks.push(new TaskObject(currentTask, timelineStartInMills, getOffsetByTaskId(currentTask.id, truckBoxEl, null, null, loads)));
                    continue;
                }

                if (!currentTask.taskIdToTheLeft) {
                    if (currentTimeRef && currentTimeRef.current) {
                        nextCurrentTimeDependenTasks = true;
                        leftBorderOffset = calculateOffset(currentTimeRef.current.toMillis(), timelineStartInMills);
                    }
                } else {
                    leftBorderOffset = getOffsetByTaskId(currentTask.taskIdToTheLeft, truckBoxEl, nextTasks, true, loads);
                    if (leftBorderOffset === null) continue;
                }

                while (currentTask && !currentTask.nextTaskIsLongTask && i < stopsAndTasksObject.timeUnspecifiedTasks.length && rightBorderOffset === null) {
                    rightBorderOffset = getOffsetByTaskId(currentTask.taskIdToTheRight, truckBoxEl, nextTasks, false, loads);
                    if (rightBorderOffset === null) {
                        i++;
                        currentTask = stopsAndTasksObject.timeUnspecifiedTasks[i];
                    }
                }

                let tasksCount = i + 1;
                if (rightBorderOffset === null) {
                    if (!currentTask || !currentTask.nextTaskIsLongTask) tasksCount--;
                    const startIndexCopy = startingTaskIndex;
                    while (startingTaskIndex < tasksCount) {
                        nextTasks.push(new TaskObject(
                            stopsAndTasksObject.timeUnspecifiedTasks[startingTaskIndex],
                            timelineStartInMills,
                            leftBorderOffset + (((startingTaskIndex - startIndexCopy) * (TASK_WIDTH_IN_PIXELS * 1.5)) + (TASK_WIDTH_IN_PIXELS / 2))
                        ));
                        startingTaskIndex++;
                    }
                } else {
                    let distanceBetweenTask = ((rightBorderOffset - leftBorderOffset) - (TASK_WIDTH_IN_PIXELS * tasksCount)) / (tasksCount + 1);
                    if (distanceBetweenTask < 0) distanceBetweenTask = 0;

                    while (startingTaskIndex < tasksCount) {
                        nextTasks.push(new TaskObject(
                            stopsAndTasksObject.timeUnspecifiedTasks[startingTaskIndex],
                            timelineStartInMills,
                            rightBorderOffset - ((tasksCount - startingTaskIndex) * (distanceBetweenTask + TASK_WIDTH_IN_PIXELS))
                        ));
                        startingTaskIndex++;
                    }
                }

                if (currentTask && currentTask.nextTaskIsLongTask && stopsAndTasksObject.longTasks && stopsAndTasksObject.longTasks.length > 0) {
                    let lastLongTaskId = null;
                    for (const longTask of stopsAndTasksObject.longTasks) {
                        if (longTask.taskIdToTheLeft === currentTask.id || lastLongTaskId === longTask.taskIdToTheLeft) {
                            nextTasks.push(new HomeTime(
                                longTask,
                                timelineStartInMills,
                                getOffsetByTaskId(longTask.taskIdToTheLeft, truckBoxEl, nextTasks, true, loads),
                                getOffsetByTaskId(longTask.taskIdToTheRight, truckBoxEl, nextTasks, false, loads),
                                currentTimeRef
                            ));
                        }
                        lastLongTaskId = longTask.id;
                    }
                }
            }
        }

        // Extra stops are currently drawn imperatively into LoadsCard.
        // Do it after DOM commit (layout effect), so querySelector sees the latest nodes.
        for (const key of Object.keys(stopsAndTasksObject)) {
            if (key === 'longTasks' || key === 'timeSpecifiedTasks' || key === 'timeUnspecifiedTasks') continue;
            const loadStops = stopsAndTasksObject[key];
            const loadDiv = truckBoxEl.querySelector(`[data-load-id="${key}"]`);
            if (loadDiv) {
                loadDiv.querySelectorAll(":scope > span")?.forEach(span => span.remove());
                for (let i = 0; i < loadStops.length; i++) {
                    const extraStop = document.createElement('span');
                    extraStop.className = `${styles.extraStop}`;
                    extraStop.style.left = `min(${loadStops[i]}%, calc(100% - 3.7rem))`;
                    loadDiv.insertBefore(extraStop, loadDiv.lastElementChild);
                }
            }
        }

        setTasks(nextTasks);
        setCurrentTimeDependenTasks(nextCurrentTimeDependenTasks);
    }, [
        plannerTick,
        truckBoxRef,
        stopsAndTasksObject,
        loads,
        timelineStartInMills,
        currentTimeRef,
        lastSpecifiedOffset,
        lastSpecifiedOffsetForCompletedTasks,
    ]);

    // Keep the existing scheduler contract: plannerViewTeamCard calls this every ~30 mins.
    useEffect(() => {
        if (!trucksSetDataMethodsObject || !truckNumber) return;
        if (currentTimeDependenTasks) {
            if (!trucksSetDataMethodsObject["trucksWithTimeDependentTasks"]) {
                trucksSetDataMethodsObject["trucksWithTimeDependentTasks"] = {};
            }
            trucksSetDataMethodsObject["trucksWithTimeDependentTasks"][truckNumber] = {
                lastUpdate: Date.now(),
                updateTasks: () => {
                    try {
                        const bumpPlannerTick = useBoardStore.getState().bumpPlannerTick;
                        if (typeof bumpPlannerTick === "function") bumpPlannerTick();
                    } catch (e) { }
                },
            };
        } else if (trucksSetDataMethodsObject["trucksWithTimeDependentTasks"]) {
            delete trucksSetDataMethodsObject["trucksWithTimeDependentTasks"][truckNumber];
        }

        return () => {
            try {
                if (trucksSetDataMethodsObject["trucksWithTimeDependentTasks"]) {
                    delete trucksSetDataMethodsObject["trucksWithTimeDependentTasks"][truckNumber];
                }
            } catch (e) { }
        };
    }, [trucksSetDataMethodsObject, truckNumber, currentTimeDependenTasks]);
    // console.log(tasks);
    let addTaskButtonOffset = trucksSetDataMethodsObject?.currentTimeMarkerX;
    if (addTaskButtonOffset) {
        addTaskButtonOffset = [addTaskButtonOffset, addTaskButtonOffset + 50];
    }
    if (loads && loads.length > 0) {
        const lastLoad = loads[loads.length - 1];
        if (lastLoad.currentLoad) {
            addTaskButtonOffset = lastLoad.startOffset + lastLoad.width;
            addTaskButtonOffset = [addTaskButtonOffset, addTaskButtonOffset + 60];
        }
        // let prevLoadEndOffset = null;
        // for(let i = 0; i < loads.length; i++){

        //     const load = loads[i];
        //     if(load.currentLoad){
        //         if(addTaskButtonOffset === null){
        //             if((load.startOffset - currentTimeMarkerX) > 20){
        //                 addTaskButtonOffset = [currentTimeMarkerX];
        //             }else{
        //                 addTaskButtonOffset = [];
        //             }
        //         }else{
        //             if(prevLoadEndOffset && (load.startOffset - prevLoadEndOffset) > 40){
        //                 addTaskButtonOffset.push(prevLoadEndOffset);
        //             }
        //         }
        //         prevLoadEndOffset = load.startOffset + load.width;
        //         if(i === loads.length-1){
        //             addTaskButtonOffset.push(prevLoadEndOffset);
        //         }
        //     }
        // }
    }
    let taskCountAfter = 0;
    if (tasks.length > 0 && addTaskButtonOffset) {
        const sortedTasks = [...tasks].sort((a, b) => a.startOffset - b.startOffset);
        for (const task of sortedTasks) {
            if ((task.startOffset >= addTaskButtonOffset[0] && task.startOffset <= addTaskButtonOffset[1] + 10) || (task.startOffset < addTaskButtonOffset[0] && task.startOffset + (task.width < 15 ? 0 : task.width)) >= addTaskButtonOffset[1]) {
                addTaskButtonOffset[0] = task.startOffset + (task.width < 15 ? 30 : task.width);
                addTaskButtonOffset[1] = addTaskButtonOffset[0] + 60;
            } else if (addTaskButtonOffset[1] < task.startOffset) {
                taskCountAfter++;
            }
        }
    }
    return <>
        {addTaskButtonOffset ? <AddTaskOrLoadButton offset={addTaskButtonOffset} addAtIndex={taskCount - taskCountAfter} truckId={truckId} truckNumber={truckNumber} /> : null}
        {
            tasks.length < 1 ? null :
                tasks.map((task) => {
                    return <TaskBlock key={task.id} taskData={task} overflowContainer={overflowContainer} popupViewManagingObject={popupViewManagingObject} truckId={truckId} />
                })
        }
    </>
})
const AddTaskOrLoadButton = memo(({ offset, addAtIndex, truckId, truckNumber}) => {
    return <div className={`${styles.addTaskOrLoadButton} addLoadOrTaskButton`} style={{ left: offset[0] + 5, width: offset[1] - offset[0] + 5 }}
        onClick={() => {
            if (!canSeeLoadRates()) {
                AddNewTaskMethod(null, () => { }, truckId, addAtIndex, null);
                return;
            }
            addPopup({
                content: Form, popupData:
                {
                    configuration: {
                        formTitle: "Add Load/Task",
                        oneButtonMode: true,
                        selectMode: true,
                        options: [
                            {
                                label: "New Load",
                                action: () => {
                                    AddLoadToTruckPopup(truckId, truckNumber, null, () => { });
                                    // AddOrEditCustomTask(taskList, setTasks, truckId, atIndex, currentTask, true);
                                },
                            },
                            {
                                label: "New Task",
                                action: () => {
                                    AddNewTaskMethod(null, () => { }, truckId, addAtIndex, null);
                                },
                            },
                        ]
                    }
                }, postSuccessAction: () => { }, EZCloseAllowed: true
            })
            // addPopup({content:Form, popupData:{configuration: {
            //     formTitle: "Add Task",
            //     oneButtonMode: true,
            //     selectMode: true,
            //     options: [
            //         {
            //             label: "Home Time / Reset",
            //             action: () => {
            //                 AddOrEditCustomTask(taskList, setTasks, truckId, atIndex, currentTask, true);
            //             },
            //         },
            //         {
            //             label: "Custom Task",
            //             action: () => {
            //                 AddOrEditCustomTask(taskList, setTasks, truckId, atIndex, currentTask);
            //             },
            //         },
            //     ]
            // }}, postSuccessAction: ()=>{}, EZCloseAllowed:true})
        }}
    >
        <span><RiAddLine /></span>
    </div>
})